// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YC_vZ","type":"styles_type__3OjMH","choices":"styles_choices__1CELl"};